import { CUSTOMER_STATUS_LEVELS } from "@lemmonhq/types";

export const RESERVATION_STATUS_COLORS: Record<string, string> = {
  confirmed: "bg-blue-500/15 text-blue-400 border-blue-500/25",
  seated: "bg-amber-500/15 text-amber-400 border-amber-500/25",
  completed: "bg-success/15 text-success border-success/25",
  "no-show": "bg-error/15 text-error border-error/25",
  cancelled: "bg-base-content/10 text-base-content/40 border-base-content/15",
  cancelled_by_user: "bg-base-content/10 text-base-content/40 border-base-content/15",
  cancelled_by_host: "bg-base-content/10 text-base-content/40 border-base-content/15",
  pending: "bg-primary/10 text-primary border-primary/20",
  arrived: "bg-info/15 text-info border-info/25",
};

export const CUSTOMER_STATUS_OPTIONS = [
  {
    value: CUSTOMER_STATUS_LEVELS.NEW,
    labelKey: "reservations.customers.new",
  },
  {
    value: CUSTOMER_STATUS_LEVELS.REGULAR,
    labelKey: "reservations.customers.regular",
  },
  {
    value: CUSTOMER_STATUS_LEVELS.VIP,
    labelKey: "reservations.customers.vip",
  },
  {
    value: CUSTOMER_STATUS_LEVELS.INACTIVE,
    labelKey: "reservations.customers.inactive",
  },
] as const;

export type ActiveSection = "overview" | "orders" | "reservations";
